import React from "react";
import twoBg from "../../assets/images/background/image-5.jpg";
import threebg from "../../assets/images/background/image-6-2.jpg";
import { Link } from "react-router-dom";
import bgfive from "../../assets/images/background/image-5.jpg";
import bg12 from "../../assets/images/background/bg-12.png";
import bg13 from "../../assets/images/background/bg-13.png";

function Winningchef() {
  return (
    <>
      <section className="fluid-section">
        <div className="outer-container">
          <div className="row clearfix">
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div
                className="inner wow fadeInLeft"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div
                  className="image-layer"
                  style={{ backgroundImage: `url(${twoBg})` }}
                ></div>

                <div className="image">
                  <img src={bgfive} alt="" />
                </div>
              </div>
            </div>

            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="right-bg">
                <img src={bg12} alt="" title="" />
              </div>
              <div
                className="inner clearfix wow fadeInRight"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div className="content-box">
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>JUST TREAT YOURSELF</span>
                    </div>
                    <div className="pattern-image">
                      <img
                        src={
                          require("../../assets/images/icons/separator.svg")
                            .default
                        }
                        alt="mySvgImage"
                      />
                    </div>
                    <h2>Delicious Moments Await at Zad Cafe</h2>
                    <div className="text">
                      Zad Cafe was created with a passion for bringing people
                      together over great food, rich coffee, and a warm,
                      inviting atmosphere. We take pride in crafting a menu that
                      blends quality and creativity, using fresh, seasonal
                      ingredients to create comforting yet exciting dishes. From
                      expertly brewed coffee fresh made pastries and wholesome
                      meals, every bite is made with care to offer a memorable
                      experience. More than just a cafe, Zad is a space where
                      you can relax, connect, and savor the little moments that
                      make life special.
                    </div>
                  </div>
                  <div className="info">
                    {/* <div className="signature">
                      <img src={signaturetwo} alt="" title="" />
                    </div>
                    <div className="author">Henry - EXCUTIVE CHEF</div> */}
                  </div>
                  <div className="link-box">
                    <Link
                      to="/menu"
                      className="theme-btn btn-style-two clearfix"
                    >
                      <span className="btn-wrap">
                        <span className="text-one">OUR MENU</span>
                        <span className="text-two">OUR MENU</span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fluid-section alternate">
        <div className="outer-container">
          <div className="row clearfix">
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div
                className="inner wow fadeInLeft"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div
                  className="image-layer"
                  style={{ backgroundImage: `url(${threebg})` }}
                ></div>
                <div className="image">
                  <img src={threebg} alt="" />
                </div>
              </div>
            </div>

            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="left-bg">
                <img src={bg13} alt="" title="" />
              </div>
              <div
                className="inner clearfix wow fadeInRight"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div className="content-box">
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>Delightful Experience</span>
                    </div>

                    <div className="pattern-image">
                      <img
                        src={
                          require("../../assets/images/icons/separator.svg")
                            .default
                        }
                        alt="mySvgImage"
                      />
                    </div>

                    <h2>Your perfect venue for gatherings and celebrations!</h2>
                    <div className="text">
                      Our elegant celebration hall at Zad Cafe is the perfect
                      setting for your special moments. Whether it’s a birthday,
                      anniversary, corporate event, or intimate gathering, we
                      offer a warm and stylish space paired with delicious food
                      and exceptional service. Let us make your celebrations
                      unforgettable with a cozy ambiance, personalized
                      arrangements, and a menu crafted to delight every guest.
                    </div>
                  </div>
                  <div className="link-box">
                    <Link to="#" className="theme-btn btn-style-two clearfix">
                      <span className="btn-wrap">
                        <span className="text-one">Discover Now</span>
                        <span className="text-two">Discover Now</span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Winningchef;
